// /src/Saga/saga.js
import { put, takeEvery } from "redux-saga/effects";

function* updateNotificationCount(action) {
  try {
    yield put({
      type: "SET_NOTIFICATION_COUNT",
      payload: action.payload,
    });
  } catch (error) {
    console.error("Saga error:", error);
  }
}

export function* watchUpdateNotificationCount() {
  yield takeEvery("UPDATE_NOTIFICATION_COUNT", updateNotificationCount);
}
